import { gql } from "@apollo/client";

export const getCurrentReferralRewardCampaigns = gql`
  query getCurrentReferralRewardCampaigns {
    CurrentReferralRewardCampaigns {
      extendedAttributes
    }
  }
`;
